import React, { useContext, useState } from 'react'
import { config } from '../server'
import { PlanContext } from '../Store'
import { Link } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react';
import '../styles/login.css'


const address = config.url.API_URL
const TutorProfile = () => {
    //const [file, setFile] = React.useState("");
    //const [userDep] = React.useContext(IsLoggedContext)
    const [, setPicture] = React.useState('')
    const [bio, setBio] = React.useState('')
    const [,setPlan] = useContext(PlanContext)
    const [inPerson, setInPerson] = useState(false)
    const [virtual, setVirtual] = useState(true)
    const [requests, setRequests] = useState([])
    const [edit, setEdit] = useState(false)
    const [holdingBio, setHolder] = useState('')
    const [math, setMath] = useState(false)
    const [science, setScience] = useState(false)
    const [english, setEnglish] = useState(false)
    const [socialStudies, setStudies] = useState(false)
    const [location, setLocation] = useState('')
    const [name, setName] = useState('')
  //  const [status, setStatus] = React.useState(false)
    const { user, isAuthenticated, isLoading, logout } = useAuth0();

    React.useEffect(() => {
        const getPicture = async () => {
            let res = await fetch(address + `/api/${user.nickname}/profilePicture`)
            let data = await res.json()
            setPicture(data.profilePicture)
        }
        const getBio = async () => {
            let res = await fetch(address + `/api/${user.nickname}/bio`)
            let data = await res.json()
            setBio(data.tutorBio)       
            setHolder(data.tutorBio) 
        }
        const getRequests = async () => {
            let res = await fetch(address + `/api/${user.nickname}/tutorRequests`)
            let data = await res.json()
            setRequests(data.allRequests)        
        }
        const getName = async () => {
			const response = await fetch(address + `/api/${user.email}/getUser`)
        	const data1 = await response.json()
			setName(data1.name)
		}

        const getStatus = async () => {
            let res = await fetch(address + `/api/${user.email}/status`)
            let data = await res.json()
            setVirtual(data.virtual)
            setInPerson(data.inPerson)  
            setMath(data.math)      
            setEnglish(data.english)
            setScience(data.science)
            setStudies(data.socialStudies)
            setLocation(data.location)
        }

        getRequests()
        getPicture()
        getBio()
        getStatus()
        getName()
    }, [user])


    /*const handleSelection = async (event) => {
        event.preventDefault()
        setFile(event.target.files[0]);
      }*/

    /*const handleUpload = async (e) => {
        e.preventDefault()
        let formData = new FormData();
        formData.append("username", user.nickname);
        formData.append("image", file);
  
  
          let response = await fetch(address + '/api/upload', {
          method: 'POST',
          body: formData
          });
  
      let result = await response.json();
        if(result.status === "success") {
            setPicture(result.imageLink)
            setFile('')
        }
    }*/

    /*const handleName = async (e) => {
        e.preventDefault()
      const requestOptions1 = {
        method: 'POST',
        headers: { 
        'content-type': 'application/json' },
        body: JSON.stringify({ name: name, email: user.email })
      };
      const res = await fetch(address + '/api/signUp', requestOptions1)
      const data = await res.json()
      if(data.status === 'success') {
          alert('Name saved!')
      }
    }*/

    const handleRedirect = async (e) => {
		e.preventDefault()
		const requestOptions = {
			method: 'POST',
			headers: { 
			'content-type': 'application/json' }
		};
		const response = await fetch(`${address}/create-customer-portal-session`, requestOptions);
		const data = await response.json()
		window.location.href = data.portalSession
		//window.location.replace(data.portalSession);
		//sendMail(data.portalSession)
	}

    const handleLogout = (e) => {
		setPlan('')
		logout({ returnTo: 'https://clusterfy.app/sign-up' })
	}

    const handleBio = async (e) => {
        e.preventDefault()
       const requestOptions = {
            method: 'POST',
            headers: { 
            'content-type': 'application/json' },
            body: JSON.stringify({ username: user.nickname, bio: holdingBio })
        };
        await fetch(address + '/api/createBio', requestOptions)
        setBio(holdingBio)
        setEdit(!edit)
    }

   function handleInputChange() {
        setInPerson(!inPerson)
      }

      if(isLoading) {
          return (
              <div>
                  Loading...
              </div>
          )
      }

      /*
            <div className="level-item">
                <img src={profilePicture} alt="profile"/>
            </div>
      */

      /*
            <div className="level-item">
            <form onSubmit={handleUpload}>
            <input type="file" onChange={handleSelection} />
            <p>Filename: {file && file.name}</p>
            <p>File type: {file && file.type}</p>
            <p>File size: {file && file.size} bytes</p>
            {file && <ImageThumb image={file} />}
            <div className="level-item">
            <input type='submit' className="tealBtn"/>
            </div>
            </form>

            </div>
      */

            const handleVirtual = async () => {
                const requestOptions = {
                    method: 'POST',
                    headers: { 
                    'content-type': 'application/json' },
                    body: JSON.stringify({ virtual: virtual, inPerson: inPerson, 
                    math: math, english: english, science: science, social: socialStudies, 
                    location: location, picture: user.picture, fullName: name})
                };
                await fetch(address + `/api/${user.nickname}/virtual`, requestOptions)
                const requestOptions1 = {
                    method: 'POST',
                    headers: { 
                    'content-type': 'application/json' },
                    body: JSON.stringify({ name: name, email: user.email })
                  };
                  const res = await fetch(address + '/api/tutorName', requestOptions1)
                  const data = await res.json()
                  if(data.status === 'success') {
                    alert('Changes saved!')
                }
            }


    return (
        isAuthenticated && (
        <div>

				<div className="heroContainer">
				<div className="level-item">
					<img src={user.picture} alt="profile" />
               
				</div>



                <div>
                    {name.length < 1 && <h1>Role: Tutor</h1>}
					{name.length > 0 && <h1>{name}</h1>}
                </div>
				{user.sub.indexOf('facebook') < -1 && <h2>username: {user.name}</h2>}
                {user.sub.indexOf('facebook') > -1 && <h2>username: {user.nickname}</h2>}
           {edit && <div>
            <form onSubmit={handleBio} className="control">
                <div style={{textAlign: 'center'}}>
                    <p>
                        Edit bio
                     </p>
                <div className="field" style={{marginRight: '25%', marginLeft: '25%'}}>
                    <div className="control">
                    <textarea maxLength={150} onChange={e => setHolder(e.target.value)} 
                    rows={3} className="textarea" value={holdingBio}/>
                    </div>
                </div>


                </div>
                <br/>
                <div style={{textAlign: 'center'}}>
                    <button className="button is-danger" onClick={() => setEdit(!edit)}>Cancel</button>
                    <input type='submit' className="button is-info"/>
                </div>
            </form>



            </div> 
            }

            {!edit && (
            <>
                <p>{bio}</p> 
                {location.length < 2 && inPerson && <p>Location: Please indicate a location</p>}
                <button className="blueBtn" onClick={() => setEdit(!edit)}>Edit</button>
            </>
            )}

				</div>
            <div className="subNav">
            <h3 className="has-text-weight-bold">I can tutor...</h3>
                <label>
                In Person
                <input
                name="isGoing"
                type="checkbox"
                checked={inPerson}
                onChange={() => handleInputChange()} />
                </label>
        <label>
          Virtually
          <input
            name="isGoing"
            type="checkbox"
            checked={virtual}
            onChange={() => setVirtual(!virtual)} />
        </label> 
                <h3 className="has-text-weight-bold">I am proficient at...</h3>
        <label>
          Math
          <input
            name="isGoing"
            type="checkbox"
            checked={math}
            onChange={() => setMath(!math)} />
        </label> 
        <label>
          Science
          <input
            name="isGoing"
            type="checkbox"
            checked={science}
            onChange={() => setScience(!science)} />
        </label> 
        <label>
          English
          <input
            name="isGoing"
            type="checkbox"
            checked={english}
            onChange={() => setEnglish(!english)} />
        </label> 
        <label>
          Social Studies
          <input
            name="isGoing"
            type="checkbox"
            checked={socialStudies}
            onChange={() => setStudies(!socialStudies)} />
        </label> 
        <br/>
        <h3 className="has-text-weight-bold">My name is</h3>
			<input type="text" className="input" placeholder="Please enter a name" 
			style={{width: '50%'}} value={name} onChange={e => setName(e.target.value)} />
       {inPerson && <h3 className="has-text-weight-bold">I am from...</h3>}
       {inPerson && <input type="text" className="input" placeholder="Please enter where your from" style={{width: '50%'}} value={location} onChange={e => setLocation(e.target.value)} />}
       <br/>
        <button type="submit" className="subNavBtn" onClick={() => handleVirtual()}>Save</button>
            <br/>
  				<button className="subNavBtn" type="submit" onClick={e => handleRedirect(e)}>Manage Billing</button>
				<button className="subNavBtn" onClick={e => handleLogout(e)}>Log Out</button>
			</div>



        <div style={{textAlign: 'center'}}>

        </div>
            <div className="level-item">
                Check your email for students requesting you to tutor!
            </div>

<div className="level-item">
    {requests.map((student, index) => (
                <div key={index} style={{width: '50%'}}>
					<div key={JSON.stringify(student._id)} style={{paddingBottom: '2.5%'}}>
						<div key={index} className="spaceCard" style={{backgroundColor: '#d3d3d3'}}>
							<div key={index} className="spaceCardText">
								<div key={index} className="spaceCardTitle">
									{student.requestingStudent}
								</div>
								
							</div>
							<Link key={index+95} className="spaceCardBtn" to="/">
								<div>View</div>
							</Link>
						</div>
					</div>
                </div>
				))}
</div>


        </div>
        )
    )
}

/*const ImageThumb = ({ image }) => {
    return <img src={URL.createObjectURL(image)} alt={image.name} />;
  };*/

export default TutorProfile